import domContentLoaded from 'dom-content-loaded';
import { throttle } from 'throttle-debounce';

export default () => {
	class ToggleMenu {
		constructor() {
			this.triggers = document.querySelectorAll('.js_togglemenu_trigger, .js_togglemenu_cover');
			this.content = document.querySelector('.js_togglemenu');
			this.body = document.body;
			this.bool = this.content.classList.contains('is_active');
			this.scrollAmount = Math.trunc(window.scrollY);
			this.breakpoint = 1024;
			this.windowWidth = window.innerWidth;
			this.init();
		}

		init() {
			this.triggerClick();
			this.windowResize();
		}

		// トリガーのクリックイベント
		triggerClick() {
			for (const trigger of this.triggers) {
				trigger.addEventListener('click', () => {
					this.windowWidth = window.innerWidth;
					this.bool = this.content.classList.contains('is_active');
					this.toggleMenu();
				});
			}
		}

		// ウインドウのリサイズイベント
		windowResize() {
			window.addEventListener(
				'resize',
				throttle(200, () => {
					this.bool = this.content.classList.contains('is_active');
					if (this.windowWidth !== window.innerWidth && window.innerWidth >= this.breakpoint && this.bool) {
						this.closeMenu();
					}
				})
			);
		}

		// ボディのスクロールを止める
		lockScrollBody() {
			this.scrollAmount = Math.trunc(window.scrollY);
			this.body.style.top = `${this.scrollAmount * -1}px`;
			this.body.classList.add('is_locked');
		}

		// ボディのスクロールを解除
		unlockScrollBody() {
			this.body.classList.remove('is_locked');
			window.scrollTo(0, this.scrollAmount);
			this.body.style.top = '';
		}

		// メニューを閉じる
		closeMenu() {
			this.unlockScrollBody();
			this.content.classList.remove('is_active');
			this.content.classList.add('is_passive');
			for (const _trigger of this.triggers) {
				_trigger.classList.remove('is_active');
				_trigger.classList.add('is_passive');
			}
		}

		// メニューを開く
		openMenu() {
			this.lockScrollBody();
			this.content.classList.remove('is_passive');
			this.content.classList.add('is_active');
			for (const _trigger of this.triggers) {
				_trigger.classList.remove('is_passive');
				_trigger.classList.add('is_active');
			}
		}

		// メニューの開閉
		toggleMenu() {
			if (this.bool) {
				this.closeMenu();
			} else {
				this.openMenu();
			}
		}
	}

	domContentLoaded(() => {
		new ToggleMenu();
	});
};
